import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=048f6f3d&"
import script from "./CustomSearch.vue?vue&type=script&lang=js&"
export * from "./CustomSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=048f6f3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports